import { render, staticRenderFns } from "./select-boards.vue?vue&type=template&id=4075a9a0&"
import script from "./select-boards.vue?vue&type=script&lang=js&"
export * from "./select-boards.vue?vue&type=script&lang=js&"
import style0 from "./select-boards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports